import React from 'react'

const Landing_new = () => {
  return (
    <>
          <div className='bg-gradient-to-b from-[#000000] to-[#7469FF]'>
          <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2 items-center">
            <div className="relative overflow-hidden lg:order-last order-last flex flex-col rounded-3xl drop-shadow-[0_20px_30px_rgba(236,57,42,0.25)]">
              <img
                alt="Wallet Digital"
                src="https://img.invupos.com/clauweb/Landing/hero-landing.webp"
                className="object-cover w-full h-[520px] rounded-3xl"
              />
            </div>
            <div className="lg:py-28 text-left">
            <h1 className="text-8xl font-semibold sm:text-9xl text-white">
                <span>C</span>
                <span className="relative inline-block">
                    <span className="relative z-10">LAU.IO</span>
                    <span
                    className="
                        absolute
                        top-1/3   
                        left-3
                        w-full
                        h-16        
                        bg-gradient-to-r from-[#F6F4F4] to-transparent
                        -z-10        
                    "
                    />
                </span>
                </h1>
              <p className="mt-8 text-gray-100 text-2xl w-full tracking-normal leading-relaxed">
              Es todo lo que tu negocio necesita centralizado en un solo lugar, Paginas web, app moviles, integraciones delivery, integraciónes con sistemas POS, Fidelizacion de cleintes y mucho más.
              </p>
              <div className="mt-8">
                <a
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-16 py-4 text-lg font-medium text-[#1F2331] hover:bg-transparent hover:text-[#fff] focus:ring-3 focus:outline-hidden"
                  href="#"
                >
                 Revoluciona Tu Negocio 
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
      <h2 className="text-5xl sm:text-6xl font-extrabold text-[#1d1d1f] py-10 mb-8 md:mb-0 text-left md:text-center md:mb-6 lg:mb-0">
    Simplifica tus <span className="text-[#FE7066] text-5xl lg:text-8xl">operaciones</span> <br/> de forma rapida.
    </h2>
  <div className="grid gap-16 sm:grid-cols-2 lg:grid-cols-3">
    <div>
        <img class="object-cover object-center w-full h-64 rounded-3xl lg:h-80" src="https://img.invupos.com/clauweb/Landing/invu-screen.webp" alt=""/>
        <div class="mt-8">
            <h2 class="mt-4 text-4xl font-bold text-gray-800">
            Lealtad</h2>
            <p class="mt-4 text-gray-500 text-xl tracking-normal leading-relaxed">
              Te ofrecemos herramientas personalizables para llevar la lealtad de tus clientes al siguiente nivel
            </p>
        </div>
    </div>

    <div>
        <img class="object-cover object-center w-full h-64 rounded-3xl lg:h-80" src="https://img.invupos.com/clauweb/Landing/wallet-nfc.webp" alt=""/>
        <div class="mt-8">
            <h2 class="mt-4 text-4xl font-bold text-gray-800">
            Wallet y NFC</h2>
            <p class="mt-4 text-gray-500 text-xl tracking-normal leading-relaxed">
            Los productos NFC son ideales para agilizar las transacciones y ofrecer soluciones modernas en el punto de venta.
            </p>
        </div>
    </div>

    <div>
        <img class="object-cover object-center w-full h-64 rounded-3xl lg:h-80" src="https://img.invupos.com/clauweb/Landing/Mockup-ecommerce.webp" alt=""/>
        <div class="mt-8">
            <h2 class="mt-4 text-4xl font-bold text-gray-800">
            E-commerce</h2>
            <p class="mt-4 text-gray-500 text-xl tracking-normal leading-relaxed">
            Ofrecemos soluciones adaptadas a tus necesidades para mejorar la experiencia de compra digital de tus clientes.
            </p>
        </div>
    </div>


  </div>
</div>



<section>
      <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2">
        <div className="relative overflow-hidden lg:order-first order-last flex flex-col items-center">
            <img
              alt="Wallet Digital"
              src="https://img.invupos.com/clauweb/Landing/Cards.webp"
              className="object-cover w-full h-full sm:h-full"
            />
          </div>
          <div className="text-left">
          <div className="">
      {/* Item 01 */}
      <div className="flex items-start space-x-6 mb-10">
        <span className="text-6xl font-bold text-gray-300 leading-none">01</span>
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">
            Acumulación de puntos y recompensas personalizadas
          </h2>
          <p className="mt-4 text-gray-500 text-lg w-full tracking-normal leading-relaxed">
            Los clientes pueden ganar puntos, millas o descuentos exclusivos al usar el wallet, 
            incentivando su regreso al comercio.
          </p>
        </div>
      </div>

      <div className="flex items-start space-x-6 mb-10">
        <span className="text-6xl font-bold text-gray-300 leading-none">02</span>
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">
            Fideliza a tus clientes y recompénsalos en cada compra
          </h2>
          <p className="mt-4 text-gray-500 text-lg w-full tracking-normal leading-relaxed">
            Con la wallet digital, los comercios pueden enviar ofertas personalizadas y 
            notificaciones exclusivas directamente al dispositivo del usuario.
          </p>
        </div>
      </div>

      <div className="flex items-start space-x-6 mb-12">
        <span className="text-6xl font-bold text-gray-300 leading-none">03</span>
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">
            Facilidad de pago y conveniencia
          </h2>
          <p className="mt-4 text-gray-500 text-lg w-full tracking-normal leading-relaxed">
            La rapidez y simplicidad del wallet digital eliminan las fricciones en el proceso 
            de pago, ofreciendo una experiencia más fluida y conveniente.
          </p>
        </div>
      </div>

      <div className="flex gap-8">
      <a
  >
    <div className="w-48 h-20">
      <img
        src="https://img.invupos.com/clauweb/Landing/Add_to_Google_Wallet_badge.png"
        alt="Download on the App Store"
        className="w-full h-full object-contain"
      />
    </div>
  </a>
  <a
  >
    <div className="w-48 h-20">
      <img
        src="https://img.invupos.com/clauweb/Landing/Add_to_Apple_Wallet_badge.png"
        alt="Get it on Google Play"
        className="w-full h-full object-contain"
      />
    </div>
  </a>
            </div>
    </div>
          </div>
        </div>
      </div>
    </section>


<div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-20">
    <div className="p-8 rounded-3xl sm:p-6 bg-[#F1F1F1]">
        <div className="flex flex-col lg:flex-row lg:mt-12 mt-6">
        <div className="lg:w-3/5 content-center lg:order-last order-last flex items-center">
            <div className="grid xl:grid-cols-2 lg:grid-cols-2 grid-cols-3 sm:grid-cols-3 md:grid-cols-3 space-x-8">
            <div className="rounded-2xl">
                <div className='relative'>
                    <img
                        className="rounded-3xl object-cover"
                        src="https://img.invupos.com/clauweb/Landing/CustomWebApp.webp"
                    />
                </div>
            </div>
            <div className="rounded-2xl">
                <div className='relative'>
                    <img
                        className=""
                        src="https://img.invupos.com/clauweb/Landing/badges.webp"
                    />
                </div>
            </div>
            </div>
        </div>
        <div className="mb-6 lg:mb-0 lg:w-2/5 content-start lg:px-6 lg:mt-0 mt-6">
            <div className="text-gray-500 text-xl md:col-span-1 tracking-normal leading-relaxed">
            <h2 className="text-4xl sm:text-[45px] font-extrabold text-[#1d1d1f] mb-4">
            Automatizaciones Inteligentes
            </h2>
                <p>
                Clau te ofrece herramientas avanzadas de automatización que llevan tu estrategia de lealtad y promociones al siguiente nivel. Imagina gestionar promociones personalizadas, campañas de descuentos y programas de fidelización sin esfuerzo manual constante.
                </p>
                <div className="mt-6 mb-4">
                  <a
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-12 py-4 text-lg font-medium text-[#FF0000] focus:ring-3 focus:outline-hidden"
                  href="#"
                  >
                      Comienza Hoy
                  </a>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div>


    <div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-10">
    <div className="p-8 rounded-3xl bg-[#F1F1F1]">
        <div className="flex flex-col items-center justify-between lg:flex-row mt-8 rounded-3xl ">
        <div className="relative lg:w-1/3">
        <img
            className="w-full h-full"
            src="https://img.invupos.com/clauweb/Landing/madison.webp"
            alt="Combo del día"
        />
    </div>

    <div className="lg:max-w-3xl lg:p-12 mt-4">
        <h2 className="text-4xl text-center sm:text-5xl font-semibold text-[#1d1d1f]">
        Integraciones poderosas para tu negocio
        </h2>
        <p className="mt-6 text-gray-500 text-lg w-full tracking-normal leading-relaxed text-center">
        Nuestras  integraciones abarcan desde sistemas POS hasta plataformas de pago y delivery, creando una experiencia sin fisuras tanto para los usuarios como para tu negocio.
        </p>
        <div class="grid grid-cols-2 gap-5 text-center lg:grid-cols-6 mt-6">
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Landing/shipday.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Landing/American_Express_logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Landing/pedidosya.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Yappy-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Visa-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Mastercard-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Picker-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/ASAP-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Invu-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Powertranz-logo.png" class="block object-contain h-16" />
          </div>
          <div class="flex items-center justify-center">
            <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Uber-direct-logo.png" class="block object-contain h-16" />
          </div>
        </div>
    </div>
  </div>
    </div>
    </div>


    <div className="px-4 py-16 mx-auto md:max-w-full lg:max-w-screen-xl lg:px-8 mt-12">
  <div className="text-left max-w-[800px]">
    <h2 className="text-5xl sm:text-6xl font-extrabold text-[#1d1d1f] py-10 md:mb-0 text-left md:text-left lg:text-left md:mb-6 lg:mb-0">
    Fideliza, conecta y haz crecer
    tu negocio
    </h2>
  </div>


  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
    <div className="bg-[#F8F8F8] rounded-2xl p-10 space-y-8">
      <h3 className="text-5xl font-bold">
        Lealtad
      </h3>
      <p className="text-gray-500 text-2xl max-w-lg tracking-normal leading-relaxed ">
      La fidelización es la clave para un negocio exitoso. Recompensa a tus clientes, aumenta su lealtad y haz que vuelvan una y otra vez.
      </p>

      <div class="flex items-center justify-between w-full max-w-full p-4 rounded-md">
        <p class="text-gray-700 font-medium text-base">
          Crecimiento de visitantes
        </p>

        <p class="text-gray-900 font-extrabold text-5xl">
          80%
        </p>
      </div>

      <div class="w-full max-w-xl h-[75px] flex overflow-hidden bg-[#EAEAEA] rounded-3xl">
        <div class="progress-stripes h-full"></div>
        <div class="w-[20%] h-full flex items-center justify-center text-[#f7901e] font-extrabold text-2xl pulse-percentage">

        </div>
      </div>
    </div>

    <div class="bg-[#F8F8F8] rounded-3xl w-full max-w-4xl mx-auto">
      <div>
      <img className='border border-8 rounded-3xl' src="https://img.invupos.com/clauweb/Landing/Graph.webp"/>

      </div>
    <div className='bg-[#1F2331] p-2 rounded-3xl rounded-t-lg'>
    <div class="flex items-center bg-white px-6 py-3 rounded-full shadow-sm w-fit">
  <div class="w-14 h-14 flex items-center justify-center rounded-full bg-[#EB7162] text-[#fff]">
  <svg  xmlns="http://www.w3.org/2000/svg"  width="30"  height="30"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chart-bar"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M4 20h14" /></svg>
  </div>
  <span class="ml-4 text-xl font-semibold text-[#1d1d1f]">Data en tiempo real</span>
</div>
</div>
    </div>
  </div>
</div>;


<div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-20">
        <div className="grid gap-12 row-gap-8 lg:grid-cols-2">
          <div className="flex flex-col justify-center">
            <div className="max-w-2xl mb-6">
              <h2 className="max-w-lg mb-6 font-sans text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl sm:leading-none">
                E-commerce adaptado a tu comercio
              </h2>
              <p className="mt-8 text-gray-500 text-2xl w-full tracking-normal leading-relaxed">
                Con un E-commerce optimizado para móviles, tu negocio está siempre al alcance de tus clientes, sin importar dónde estén.
              </p>
            </div>
            <div className="grid gap-6 row-gap-6 sm:grid-cols-2">
              <div className="relative p-6 bg-[#FE7066] border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20129%281%29.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-16"
                />
                <div className="relative z-10 space-y-4">
                  <span className="text-5xl font-semibold text-white">80%</span>
                  <h3 className="inline-block mb-3 text-2xl font-bold text-white transition-colors duration-200 hover:text-deep-purple-accent-400">
                    Experiencia de Compra Rápida y Cómoda
                  </h3>
                </div>
              </div>

              <div className="p-6 bg-white border rounded-3xl shadow-sm space-y-4 items-center">
                <span className="text-5xl font-semibold text-[#25272D]">120%</span>
                <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                  Métricas y datos de ventas
                </h3>
              </div>

              <div className="relative p-6 bg-white border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20128.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-10"
                />
                <div className="relative z-10 space-y-4">
                  <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                  Conexión Directa con Tus Clientes
                  </h3>
                </div>
              </div>

              <div className="relative p-6 bg-white border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20130.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-4"
                />

                <div className="relative z-10 space-y-4">
                  <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                  Todo en un solo lugar con CLAU.IO
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover w-full h-full  sm:h-full"
              src="https://img.invupos.com/clauweb/Landing/Mockup%20EATHH..webp"
              alt=""
            />
          </div>
        </div>
      </div>



    </>
  )
}

export default Landing_new